import { useEffect, useMemo, useState } from 'react';

export const useForm = (initialForm = {}, formValidations = {}) => {

    const [formState, setFormState] = useState(initialForm);
    const [formValidation, setFormValidation] = useState({});
    // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const emailRegex = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
    const passwordRegex = /^([\w.%*+-]){6,}$/;
    const nameRegex = /^[A-Za-zÁÉÍÓÚÑáéíóúñ ]+$/;
    const phoneRegex = /^[0-9]{10}$/;
     const [errors, setErrors] = useState({});

    useEffect(() => {
        createValidators();
    }, [formState])

    useEffect(() => {
        setFormState(initialForm);
    }, [])


    const isFormValid = useMemo(() => {

        for (const formValue of Object.keys(formValidation)) {
            if (formValidation[formValue] !== null) return false;
        }

        return true;
    }, [formValidation])


    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setFormState({
            ...formState,
            [name]: value
        });
         validateField(name, value);
    }

    const onResetForm = () => {
        setFormState(initialForm);
    }

    const createValidators = () => {

        const formCheckedValues = {};

        for (const formField of Object.keys(formValidations)) {
            //console.log('formField', formValidations[formField])
            const [fn, errorMessage] = formValidations[formField];
            //console.log(fn, errorMessage)
            //formCheckedValues[`${ formField }Valid`] = fn( formState[formField] ) ? null : errorMessage;
        }

        setFormValidation(formCheckedValues);
    }

    const validateField = (name, value) => {
        let errorMsg = "";

        if (!value || value === "") {
        errorMsg = "Este campo es obligatorio";
        }
        if (name === "email" && value) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(value)) errorMsg = "Correo inválido";
        }

        if (name === "telephone" && value && value.length != 10) {
        errorMsg = "El teléfono debe tener 10 dígitos";
        }

        setErrors(prev => ({ ...prev, [name]: errorMsg }));
  };



    return {
        ...formState,
        formState,
        setFormState,
        onInputChange,
        onResetForm,
        ...formValidation,
        isFormValid,
        emailRegex,
        passwordRegex,
        phoneRegex,
        nameRegex,
        errors,
        setErrors,
    }
}